<template>
    <div class="PersonalStatistics">
        <div class="monthOrWook" v-if="calenVisible == false">
            <div class="select">
                <span :class="{'select-active':monthOrweek == true}" @click="checkOut">周</span>
                <span :class="{'select-active':monthOrweek == false}" @click="checkOut">月</span>
            </div>
            <div class="date">
                <van-icon name="arrow-left" @click="last"/>
                <span v-if="monthOrweek == true">{{monthOrweekStr}}</span>
                <span v-if="monthOrweek == false">{{monthOrweekStr}}</span>
                <van-icon name="arrow" @click="next"/>
            </div>
        </div>
        <div class="calendar">
            <div class="userinfo">
                <div class="user-head">
                    <img v-if="headerUrl != null && headerUrl != ''" :src="headerUrl" alt="">  
                    <span class="nameImg" v-else>{{nameImg}}</span>
                </div>
                <div class="info">
                    <span>{{userName}}</span>
                    <p>{{deptName}}</p>
                </div>
            </div>
            <div class="calendarBtn">
                <img v-if="calenVisible == false" src="../../assets/img/calendar.png" alt="">
                <span class="calenShow" v-if="calenVisible == false" @click="calenShow">日历显示</span>
                <span class="calenHide" @click="calenHide" v-if="calenVisible == true">{{currDate}}</span>
            </div>
        </div>  
        <van-calendar v-show="calenVisible" title="选择日期" :show-title="false" :show-subtitle="false" :poppable="false" :show-confirm="false" :default-date="defaultDate" 
            :show-mark="false" row-height="50" color="#FEC43F" :min-date="minDate" @select="selectDate" :max-date="maxDate" :style="{ height: '330px' }"/>
        <div class="chart-box">
            <div class="tab-bar">
                <div :class="{'tab-active':active == 1}" @click="tabActive">销售金额</div>
                <div :class="{'tab-active':active == 2}" @click="tabActive">回款金额</div>
            </div>
            <div class="rate">
                <div class="rate-num">
                    <div>
                        <div>{{ active == 1 ? info.realSalesAmount : info.realBackAmount}}<span>万</span> </div>
                        <p>{{ active == 1 ? '实际销售金额' : '实际回款金额' }}</p>
                    </div>
                    <div>
                        <div>{{ active == 1 ? info.planSalesAmount : info.planBackAmount}}<span>万</span> </div>
                        <p>{{ active == 1 ? '计划销售金额' : '计划回款金额' }}</p>
                    </div>
                </div>
                <div class="rate-circle">
                    <van-circle v-model="currentRate" :rate="rate" :stroke-width="60" size="110px" :clockwise="false"
                    layer-color="rgba(37,116,246,.5)" color="#2574F6" :speed="100" :text="text" />
                    <p>{{active == 1 ? '销售完成率' : '回款完成率'}}</p>
                </div>
            </div>
            <div class="chart" id="barChart" style="width: 100%; height: 200px;"></div>
            <van-row>
                <van-col span="8">
                    <div v-if="active == 1">{{ info.sameTermRate == null ? '暂无' : info.sameTermRate}}<span v-if="info.sameTermRate != null">%</span></div>
                    <div v-if="active != 1">{{ info.sameTermBackRate == null ? '暂无' : info.sameTermBackRate}}<span v-if="info.sameTermBackRate != null">%</span></div>
                    <p>同比增长率</p>
                </van-col>
                <van-col span="8">
                    <div v-if="active == 1"><span v-if="info.sameTermSalesAmount != null">￥</span>{{ info.sameTermSalesAmount == null ? '暂无' : info.sameTermSalesAmount}}<span v-if="info.sameTermSalesAmount != null">%</span></div>
                    <div v-if="active != 1"><span v-if="info.sameTermBackAmount != null">￥</span>{{ info.sameTermBackAmount == null ? '暂无' : info.sameTermBackAmount}}<span v-if="info.sameTermBackAmount != null">%</span></div>
                    <p>{{ active == 1 ? '同期销售额' : '同期回款额' }}</p>
                </van-col>
                <van-col span="8">
                    <div><span>￥</span>{{ active == 1 ? info.currSalesAmount : info.realBackAmount}}<span>万</span></div>
                    <p>{{ active == 1 ? '本期销售额' : '本期回款额' }}</p>
                </van-col>
            </van-row>
        </div>
        <div class="clue-box">
            <div class="tit-btn">
                <h2>线索统计</h2>
                <div>
                    <span :class="{'clue-active':clueActive == clueIndex}" v-for="(clue,clueIndex) in clueBtnList" :key="clue.text" @click="clueBtnClick(clueIndex)">{{clue.text}}</span>
                </div>
            </div>
            <div class="clue-num" v-if="clueActive == 0">
                <div> <div>{{info.clueFoundZj}}</div> 专家 </div>
                <div> <div>{{info.clueFoundZy}}</div> 资源人 </div>
                <div> <div>{{info.clueFoundZx}}</div> 直销户 </div>
                <div> <div>{{info.clueFoundJx}}</div> 经销户 </div>
            </div>
            <div class="clue-num" v-if="clueActive == 1">
                <div> <div>{{info.clueClaimZx}}</div> 直销户 </div>
                <div> <div>{{info.clueClaimJx}}</div> 经销户 </div>
                <div> <div>{{info.clueClaimJb}}</div> 基本 </div>
            </div>
            <div class="clue-num" v-if="clueActive == 2">
                <div> <div>{{info.clueAuditZx}}</div> 直销户 </div>
                <div> <div>{{info.clueAuditJx}}</div> 经销户 </div>
                <div> <div>{{info.clueAuditFq}}</div> 放弃 </div>
            </div>
            <div class="clue-num" v-if="clueActive == 3">
                <div> <div>{{info.clueTotalCount}}</div> 全部 </div>
            </div>
        </div>
        <div class="cus-box">
            <div class="tit-btn">
                <h2>客户统计</h2>
                <div>
                    <span :class="{'cus-active':cusActive == cusIndex}" v-for="(cus,cusIndex) in cusBtnList" :key="cus.text" @click="cusBtnClick(cusIndex)">{{cus.text}}</span>
                </div>
            </div>
            <div class="cus-num" v-if="cusActive == 0">
                <div> <div>{{info.cusZx}}</div> 直销户 </div>
                <div> <div>{{info.cusJx}}</div> 经销户 </div>
                <div> <div>{{info.cusLh}}</div> 联合户 </div>
            </div>
            <div class="cus-num" v-if="cusActive == 1">
                <div> <div>{{info.cusNewZx}}</div> 直销户 </div>
                <div> <div>{{info.cusNewJx}}</div> 经销户 </div>
            </div>
        </div>
    </div>
</template>

<script>
import echarts from 'echarts'
import { CountPersonalReport, getUserInfo } from '@/api/resetApi.js'
import { getLastWeek, getNextWeek, formatDate } from '@/utils/utils.js'
import { Toast } from 'vant'
export default {
    name:'personalStatistics',
    data(){
        return{
            userName:'',
            deptName:'',
            headerUrl:'',
            nameImg:'',
            monthOrweek:true,
            monthOrweekStr:'',
            lastWeekNum: 0,
            NextWeekNum: 0,
            lastMonthNum:0,
            nextMonthNum:0,
            minDate:new Date(2015, 0, 1),
            maxDate: new Date(2028, 0, 31),
            defaultDate:new Date(),
            calenVisible:false,
            currDate:'',
            active:1,
            currentRate:0,
            rate:0,
            clueActive:0,
            clueBtnList:[
                { text:'自建', type:1 },
                { text:'认领', type:2 },
                { text:'审核', type:3 },
                { text:'总量', type:4 },
            ],
            cusActive:0,
            cusBtnList:[
                { text:'统计', type:1 },
                { text:'新增', type:2 },
            ],
            info:{},
            queryData:{
                beginTime:null,
                endTime:null,
                countTimeType:null,
                userIds:null,
            }
        }
    },
    computed: {
        text() {
            return Number(this.currentRate).toFixed(0) + '%';
        },
    },
    created(){
        localStorage.setItem('utoken',this.$route.query.uToken)
        localStorage.setItem('ukey',this.$route.query.uKey)
        this.queryData.userIds = [this.$route.query.userId]
        this.getWeek()
        this.getuserinfo(this.$route.query.userId)
    },
    methods:{
        async getuserinfo(id){
            let res = await getUserInfo({userId:id})
            try {
                if (res.data.succ === true) {
                    this.userName = res.data.data.personName 
                    this.deptName = res.data.data.deptName
                    this.headerUrl = res.data.data.headerUrl
                    this.nameImg = this.userName.slice(-2)
                }else{
                    console.log(res.data.msg)
                    Toast(res.data.msg);
                }
            } catch (error) {
                console.log(error)
            }
        },
        selectDate(value){
            let date = formatDate(value)
            this.currDate = date +' '+ this.getWeekDate(value)
            this.queryData.beginTime = date
            this.queryData.endTime = date
            this.queryData.countTimeType = 11
            this.countPersonalReport()
        },
        calenHide(){
            this.calenVisible = false
        },
        calenShow(){
            this.calenVisible = true
            this.defaultDate = new Date()
            this.currDate = formatDate(new Date()) +' '+ this.getWeekDate(new Date())
        },
        getWeekDate(date) {
            var now = new Date(date);
            var day = now.getDay();
            var weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
            var week = weeks[day];
            return week;
        },
        // 下周下月
        next(){
            if(this.monthOrweek){
                this.lastWeekNum -= 1
                this.NextWeekNum += 1
                let nextWeek = getNextWeek(this.NextWeekNum)
                this.queryData.beginTime = nextWeek[0]
                this.queryData.endTime = nextWeek[1]
                
                this.monthOrweekStr = nextWeek[0].slice(5).replace(/-/g,'.') +' - '+ nextWeek[1].slice(5).replace(/-/g,'.')

                this.queryData.countTimeType = 2
                this.countPersonalReport()
            }else{
                this.lastMonthNum -= 1
                this.nextMonthNum += 1
                let startDate = this.$moment().month(this.$moment().month() + this.nextMonthNum).startOf('month').format('YYYY-MM-DD')
                let endDate = this.$moment().month(this.$moment().month() + this.nextMonthNum).endOf('month').format('YYYY-MM-DD')
                this.queryData.beginTime = startDate
                this.queryData.endTime = endDate
                this.monthOrweekStr = startDate.substring(0,startDate.length-3).replace(/-/g,'.')

                this.queryData.countTimeType = 4
                this.countPersonalReport()
            }
        },
        // 上周上月
        last(){
            if(this.monthOrweek){
                this.lastWeekNum += 1
                this.NextWeekNum -= 1
                let lastWeek = getLastWeek(this.lastWeekNum)
                this.queryData.beginTime = lastWeek[0]
                this.queryData.endTime = lastWeek[1]

                this.monthOrweekStr = lastWeek[0].slice(5).replace(/-/g,'.') +' - '+ lastWeek[1].slice(5).replace(/-/g,'.')
                this.queryData.countTimeType = 2
                this.countPersonalReport()
            }else{
                this.lastMonthNum += 1
                this.nextMonthNum -= 1
                let startDate = this.$moment().month(this.$moment().month() - this.lastMonthNum).startOf('month').format('YYYY-MM-DD')
                let endDate = this.$moment().month(this.$moment().month() - this.lastMonthNum).endOf('month').format('YYYY-MM-DD')
                this.queryData.beginTime = startDate
                this.queryData.endTime = endDate

                this.monthOrweekStr = startDate.substring(0,startDate.length-3).replace(/-/g,'.')
                this.queryData.countTimeType = 4
                this.countPersonalReport()
            }
        },
        getWeek(){
            if(this.monthOrweek){
                let weekStart = this.$moment().weekday(1).format('MM.DD')
                let weekEnd = this.$moment().weekday(7).format('MM.DD')
                this.monthOrweekStr = weekStart+' - '+weekEnd

                this.queryData.beginTime = this.$moment().weekday(1).format('YYYY-MM-DD')
                this.queryData.endTime = this.$moment().weekday(7).format('YYYY-MM-DD')
                this.queryData.countTimeType = 2
                this.countPersonalReport()
            }else{
                let starts = this.$moment().startOf('month').format('YYYY.MM')
                this.monthOrweekStr = starts
                
                this.queryData.beginTime = this.$moment().startOf('month').format('YYYY-MM-DD')
                this.queryData.endTime = this.$moment().endOf('month').endOf('month').format('YYYY-MM-DD');
                this.queryData.countTimeType = 4
                this.countPersonalReport()
            }
        },
        checkOut(){
            this.monthOrweek = !this.monthOrweek
            this.getWeek()
        },
        async countPersonalReport(){
            let data = this.queryData
            let res = await CountPersonalReport(data)
            try {
                if (res.data.succ === true) {
                    this.rate = this.active == 1 ? Number(res.data.data.salesCompletionRate) : Number(res.data.data.backAmountCompletionRate)
                    console.log(this.currentRate)
                    this.info = res.data.data
                    this.setBarOption(res.data.data)
                }
            } catch (error) {
                
            }
        },
        tabActive(){
            this.active = this.active == 1 ? 2 : 1;
            this.setBarOption(this.info)
        },
        clueBtnClick(index){
            this.clueActive = index
        },
        cusBtnClick(index){
            this.cusActive = index
        },
        // 柱状图配置
        setBarOption(data){
            console.log(this.active)
            let num1,num2;
            if(this.active == 1){
                num1 = data.sameTermSalesAmount
                num2 = data.currSalesAmount
            }else{
                num1 = data.sameTermBackAmount
                num2 = data.realBackAmount
            }
            // 柱状图
            var barOptions ={
                legend: {
                    data: []
                },
                tooltip:{
                    showDelay : 0,
                },
                grid: {
                    x:40,
                    x2: 5,
                    y: 20,
                    y2: 28
                },
                xAxis: [{
                    type: 'category',
                    data: [data.sameTermTimestamp,data.currTimestamp],
                    axisTick: {
                        show: false
                    }
                }],
                yAxis: [{
                    type: 'value',
                    splitLine:{
                　　　　show:false
                　　 },
                    axisTick: {
                        show: false
                    }
                }],
                series: [{
                    color:['#C33531','#EFE42A'],
                    name: '',
                    type: 'bar',
                    data: [Number(num1),Number(num2)],
                    barWidth:30,
                    itemStyle: {
                        color: function(params) { 
                            var colorList = ['#2574F6','#F5A623']; 
                            return colorList[params.dataIndex] 
                        }
                    },
                }]
            }
            var barChart = echarts.init(document.getElementById('barChart'));
            barChart.setOption(barOptions);
        }
    }
}
</script>

<style lang="scss" scoped>
.PersonalStatistics{
    font-size: 14px;
    text-align: left;
    color: #4A4A4A;
    background: #F7F7F7;
    .monthOrWook{
        background: #fff;
        height: 28px; 
        padding: 13px 12px 13px 15px;
        margin-bottom: 10px;
        display: flex;
        justify-content : space-between;
        align-items : center;
        .select{
            width: 104px;
            height: 28px;
            line-height: 28px;
            border: 1px solid #4E8CFC;
            border-radius: 4px;
            span{
                display: inline-block;
                width: 52px;
                height: 100%;
                text-align: center;
                &.select-active{
                    background: #4E8CFC;
                    color: #fff;
                }
            }
        }
        .date{
            display: flex;
            align-items : center;
            i{
                font-size: 18px;
                color: #9B9B9B;
            }
            span{
                display: inline-block;
                margin: 0 30px;
                font-size: 14px;
                color: #181818;
            }
        }
    }
    .calendar{
        background: #fff;
        height: 60px;
        padding: 0 16px;
        margin-bottom: 10px;
        display: flex;
        align-items : center; 
        justify-content : space-between;
        .userinfo{
            display: flex;
            align-items : center; 
            .user-head{
                img{
                    width: 38px;
                    height: 38px;
                    border-radius: 50%;
                    margin-right: 10px;
                }
                .nameImg{
                    display: inline-block;
                    width: 38px;
                    height: 38px;
                    border-radius: 50%;
                    margin-right: 10px;
                    background: #2574F6;
                    color: #fff;
                    font-size: 12px;
                    line-height: 38px;
                    text-align: center;
                }
            }
            .info{
                span{
                    font-size: 16px;
                    color: #4A4A4A;
                    line-height: 22px;
                }
                p{
                    color: #9B9B9B;
                    font-size: 12px;
                }
            }
        }
        .calendarBtn{
            display: flex;
            align-items : center; 
            img{
                width: 16px;
                height: 16px;
            }
            span{
                font-size: 14px;
                color: #4E8CFC;
                &.calenHide{
                    color: #4A4A4A;
                }
            }
        }
    }
    .van-calendar{
        background: #2574F6;
        color: #fff;
    }
    .chart-box{
        padding:16px;
        background: #ffffff;
        margin-bottom: 10px;
        .tab-bar{
            display: flex;
            justify-content: space-around;
            color: #9B9B9B;
            font-size: 18px;
            line-height: 25px;
            padding-bottom: 8px;
            margin-bottom: 30px;
            .tab-active{
                position: relative;
                color: #2574F6;
                font-weight: bold;
                &::before{
                    position: absolute; 
                    content: "";
                    display: block;
                    width: 50px;
                    height: 4px;
                    background: #2574F6;
                    border-radius: 15px;
                    left: 50%;
                    margin-left: -25px;
                    top: 33px;
                }
            }
        }
        .rate{
            display: flex;
            justify-content : space-between;
            padding-bottom: 20px;
            border-bottom: 1px solid rgba(239,239,239,1);
            .rate-num{
                padding-top: 5px;
                &>div{
                    margin-bottom: 20px;
                    div{
                        font-size: 28px;
                        color: #181818;
                        margin-bottom: 15px;
                        span{
                            font-size: 14px;
                            font-weight: normal;
                        }
                    }
                    p{
                        font-size: 14px;
                        color: #9B9B9B;
                    }
                }
            }
            .rate-circle{
                text-align: center;
                .van-circle{
                    margin-bottom: 10px;
                }
                p{
                    color: #9B9B9B;
                    font-size: 14px;
                }
            }
        }
        .van-row{
            margin-top: 15px;
            .van-col--8{
                padding-left: 20px;
                div{
                    font-size: 16px;
                    color: #F14F4C;
                    margin-bottom: 10px;
                    span{
                        font-size: 12px;
                    }
                }
                p{
                    color: #4C4C4C;
                    font-size: 14px;
                }
            }
        }
    }
    .clue-box,.cus-box{
        padding:16px;
        background: #ffffff;
        margin-bottom: 10px;
        .tit-btn{
            display: flex;
            justify-content : space-between;
            align-items: center;
            padding-bottom: 15px;
            border-bottom: 1px solid #EFEFEF;
            h2{
                font-size: 18px;
                color: #2574F6;
                display: inline-block;
                font-weight: bold;
            }
            div{
                span{
                    display: inline-block;
                    width: 50px;
                    height: 24px;
                    border: 1px solid #EFEFEF;
                    text-align: center;
                    line-height: 24px;
                    margin-left: 8px;
                    border-radius: 20px;
                    font-size: 14px;
                    color: #4A4A4A;
                    &.clue-active,&.cus-active{
                        background: #2574F6;
                        color: #fff;
                        border: 1px solid #2574F6;
                    }
                }
            }
        }
        .clue-num,.cus-num{
            display: flex;
            // justify-content : space-around;
            flex-direction:row;
            margin-top: 30px;
            &>div{
                text-align: center;
                margin: 0 20px;
                div{
                    width: 40px;
                    height: 40px;
                    line-height: 40px;
                    background: #2574F6;
                    font-size: 14px;
                    color: #fff;
                    margin-bottom: 8px;
                    border-radius: 50%;
                }
            }
        }
    }
}
</style>